import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getVisitorInformationQueryKey = () => QueryClientHelper.makeQueryKey('/rest/visitor/information', {});
//# sourceMappingURL=visitorKeys.js.map